import { render, staticRenderFns } from "./IconArrowRightItalic.vue?vue&type=template&id=a95e5f82"
import script from "./IconArrowRightItalic.vue?vue&type=script&lang=js"
export * from "./IconArrowRightItalic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports